import React from 'react';
import Sidebar from './components/Sidebar';
import TaskInput from './components/TaskInput';
import ResponseDisplay from './components/ResponseDisplay';

function App() {
  return (
    <div className="flex h-screen bg-[#0e0e0f] text-gray-100 font-sans overflow-hidden">
      <Sidebar />

      <main className="flex-1 flex flex-col relative">
        <header className="h-16 border-b border-gray-800 flex items-center px-8 bg-gray-900/50 backdrop-blur-sm z-10">
          <h2 className="text-lg font-medium">Command Center</h2>
        </header>

        <div className="flex-1 overflow-y-auto p-8 relative z-10">
          <div className="max-w-4xl mx-auto space-y-8">
            <section>
              <h3 className="text-2xl font-bold mb-6 text-white tracking-tight">Initiate Task</h3>
              <TaskInput />
            </section>

            <section>
              <ResponseDisplay />
            </section>
          </div>
        </div>

        {/* Ambient background glows */}
        <div className="fixed top-0 right-0 w-[40vw] h-[400px] bg-blue-500/5 blur-[120px] pointer-events-none -z-0"></div>
        <div className="fixed bottom-0 left-64 w-[30vw] h-[300px] bg-purple-500/5 blur-[100px] pointer-events-none -z-0"></div>
      </main>
    </div>
  );
}

export default App;
